// B2B revenue — partner campaigns, closed-loop payments, and loyalty white label.
//
// These lines are intentionally explicit because the investor narrative already
// references $1.5M-$3M B2B vertical revenue. The forecast should not leave that
// revenue outside the numbers.

const SCENARIO_SCALE = {
  conservative: 0.7,
  base: 0.75,
  bull: 2.8,
};

function ramp(month) {
  if (month <= 6) return 0;
  if (month <= 12) return 0.25;
  if (month <= 24) return 0.6;
  return 1;
}

export function b2bRevenue(inputs, month, scenarioKey) {
  const cfg = inputs.agenticInfra;
  if (!cfg?.enabled) {
    return { partnerCampaigns: 0, closedLoop: 0, whiteLabel: 0 };
  }

  const scale = (SCENARIO_SCALE[scenarioKey] ?? SCENARIO_SCALE.base) * ramp(month);
  const partnerCampaigns =
    (cfg.marketplaceFee?.volumeMonthly ?? 0) *
    (cfg.marketplaceFee?.rate ?? 0) *
    (cfg.marketplaceFee?.pulsarShare ?? 0);

  const closedLoop =
    (cfg.settlementTxFee?.volumeMonthly ?? 0) *
      (cfg.settlementTxFee?.ratePerTx ?? 0) *
      (cfg.settlementTxFee?.pulsarShare ?? 0) +
    (cfg.paymentStreamingFee?.volumeMonthly ?? 0) *
      (cfg.paymentStreamingFee?.rate ?? 0) *
      (cfg.paymentStreamingFee?.pulsarShare ?? 0);

  const whiteLabel =
    (cfg.portalUpgradeFee?.activeBusinesses ?? 0) *
    (cfg.portalUpgradeFee?.monthlyFeePerBusiness ?? 0) *
    (cfg.portalUpgradeFee?.pulsarShare ?? 0);

  return {
    partnerCampaigns: partnerCampaigns * scale,
    closedLoop: closedLoop * scale,
    whiteLabel: whiteLabel * scale,
  };
}
